import { V2EmcLegislationBriefing } from '../../components/V2EmcLegislationBriefing'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductEmcRegulationPageProps = {
  productId: string
}

export function V2ProductEmcRegulationPage({
  productId,
}: V2ProductEmcRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law='emc'>
      {(emcApplies) => (
        <V2EmcLegislationBriefing productId={productId} emcApplies={emcApplies} />
      )}
    </V2ProductRegulationPageShell>
  )
}
